// sessionStorage key: remembers the company picked for this browsing session so
// we don't re-prompt on reload. cleared on logout (signOut). kept dependency-free
// so both the gate and auth.utils can import it without a cycle.
export const ORG_SELECTED_KEY = "org-selected";
